import cn from 'classnames';
import React from 'react';
import {twMerge} from 'tailwind-merge';

import {MaxWidthContainer} from '../../Layout';
import Article from '../Article';

const DualLayout = (props) => {
    const {className, classNameLeft, classNameRight, articleProps, children} = props;

    return (
        <MaxWidthContainer size='l' className={twMerge('mx-auto w-full', className)}>
            <div className={'flex w-full flex-col lg:flex-row lg:justify-between lg:px-8 xl:px-0'}>
                <div
                    className={twMerge(
                        'flex flex-col items-center justify-center px-8 lg:w-4/12 lg:pl-0 lg:text-start xl:pl-0 xl:pr-16',
                        classNameLeft
                    )}
                >
                    <Article {...articleProps} />
                </div>
                <div className={twMerge(cn('order-first mb-4 lg:order-last lg:w-7/12', classNameRight))}>
                    {children}
                </div>
            </div>
        </MaxWidthContainer>
    );
};

export default DualLayout;
